<div class="frequency-container" [class.align-start]="isAlignStart()">
  <div [class.frequency-price]="!allowCustomStyling()" [class.large-frequency-price]="isLarge()">
    {{ value() }}
  </div>
  <div class="frequency-value">
    @if (currencyCode(); as code) {
      <span>&nbsp;{{ code }}</span>
    }
    @if (isVerbose()) {
      <span>&nbsp;</span>
    }
    <span>{{ frequency() | glxyFrequency: form() | translate }}</span>
  </div>
</div>
